import { makeStyles, styled } from '@material-ui/core/styles';

const BUTTON_WIDTH = '100%';
const ICON_SIZE = 40;

export const useStyles = makeStyles(theme => ({
  gridItem: {
    width: '100%',
    display: 'flex'
  },
  button: {
    width: BUTTON_WIDTH,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    flex: 1,

    backgroundColor: theme.palette.common.white,
    border: 'none',
    borderRadius: theme.spacing(2),
    color: theme.palette.primary.main,
    cursor: 'pointer',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    transition: 'all 0.3s ease',

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      boxShadow: theme.shadows[24],
      color: theme.palette.common.white,
      '& $description': {
        color: theme.palette.common.white
      }
    }
  },

  icon: {
    width: ICON_SIZE,
    height: ICON_SIZE
  },
  description: {
    transition: 'color 0.3s ease'
  }
}));

export const Container = styled('div')(({ theme }) => ({
  margin: theme.spacing(2, 0, 8, 0)
}));
